import React from 'react'

import { Box, Button, Typography } from '@material-ui/core'

import constants from 'constants/index'
import theme from 'theme'
import useStyles from './styles'

const StatusTabs = ({ currentTab, setCurrentTab }) => {
  const classes = useStyles()

  const { PROGRESS_STATUS_BUTTONS, PROGRESS_STATUS_COLOR } =
    constants.suppliers.companySuppliers

  return (
    <Box className={classes.root}>
      {PROGRESS_STATUS_BUTTONS.map((status, index) => {
        const Icon = status?.icon
        const bgColor = PROGRESS_STATUS_COLOR[status?.value]
        const isSelected = status?.id === currentTab

        return (
          <Box key={index} className={classes.gridItem}>
            <Button
              variant="outlined"
              color="primary"
              fullWidth
              className={classes.statusButton}
              onClick={() => setCurrentTab(status?.id)}
              {...(isSelected && {
                style: {
                  borderColor: theme.palette.primary.main,
                },
              })}
            >
              <Box className={classes.containerButton}>
                <Box display="flex" justifyContent="center" width="100%">
                  <Typography variant="button">{status?.name}</Typography>
                </Box>
                {!!Icon && (
                  <Box className={classes.containerIcon} bgcolor={bgColor}>
                    <Icon
                      size={20}
                      strokeWidth={2.5}
                      className={classes.statusIcon}
                    />
                  </Box>
                )}
              </Box>
            </Button>
          </Box>
        )
      })}
    </Box>
  )
}

export default StatusTabs
